import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  AangifteSchenkbelasting, APV,
  BokkzAlgDataService,
  BokkzSbDataService,
  BokkzSbLogic,
  Effecten,
  GiftTaxEntity,
  NotarieleAkte,
  OmschrijvingEnBedrag,
  OndernemingSB,
  OnroerendeZaakSB, PU, RoerendeZaak,
  Schenking, SchenkingOpPapier,
  SchenkingRelatieBegiftigdeMetSchenker, Vrijstellingen, Vruchtgebruik
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {NgIf} from "@angular/common";
import {Subscription} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-voorkoming',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    NgIf
  ],
  templateUrl: './voorkoming.component.html',
  styleUrl: './voorkoming.component.css'
})
export class VoorkomingComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private giftTaxEntitySubscription: Subscription | undefined;
  public giftTaxEntity = {} as GiftTaxEntity;
  public sbAangifte = {} as AangifteSchenkbelasting;
  public schenkingFg = {} as FormGroup;
  public hasNLOnroerendeZaken = false;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public optionsLandcodes: SelectFormControlItem<string>[] = [
    {value: "AFG", label: "Afghanistan"},
    {value: "ALA", label: "Åland Eilanden"},
    {value: "ALB", label: "Albanië"},
    {value: "DZA", label: "Algerije"},
    {value: "ASM", label: "Amerikaans Samoa"},
    {value: "UMI", label: "Amerikaanse Kleinere Afgelegen Eilanden"},
    {value: "VIR", label: "Amerikaanse Maagdeneilanden"},
    {value: "AND", label: "Andorra"},
    {value: "AGO", label: "Angola"},
    {value: "AIA", label: "Anguilla"},
    {value: "ATA", label: "Antartica"},
    {value: "ATG", label: "Antigua en Barbuda"},
    {value: "ARG", label: "Argentinië"},
    {value: "ARM", label: "Armenië"},
    {value: "ABW", label: "Aruba"},
    {value: "AUS", label: "Australië"},
    {value: "AZE", label: "Azerbeidzjan"},
    {value: "BHS", label: "Bahama's"},
    {value: "BHR", label: "Bahrein"},
    {value: "BGD", label: "Bangladesh"},
    {value: "BRB", label: "Barbados"},
    {value: "BEL", label: "België"},
    {value: "BLZ", label: "Belize"},
    {value: "BEN", label: "Benin"},
    {value: "BMU", label: "Bermuda"},
    {value: "BTN", label: "Bhutan"},
    {value: "BOL", label: "Bolivia"},
    {value: "BIH", label: "Bosnië en Herzegovina"},
    {value: "BWA", label: "Botswana"},
    {value: "BVT", label: "Bouvet"},
    {value: "BRA", label: "Brazilië"},
    {value: "IOT", label: "Brits Indische Oceaanterritorium"},
    {value: "VGB", label: "Britse Maagdeneilanden"},
    {value: "BRN", label: "Brunei"},
    {value: "BGR", label: "Bulgarije"},
    {value: "BFA", label: "Burkina Faso"},
    {value: "BDI", label: "Burundi"},
    {value: "KHM", label: "Cambodja"},
    {value: "BES", label: "Caribisch Nederland"},
    {value: "CAN", label: "Canada"},
    {value: "CAF", label: "Centraal-Afrikaanse Republiek"},
    {value: "CHL", label: "Chili"},
    {value: "CHN", label: "China"},
    {value: "CXR", label: "Christmaseiland"},
    {value: "CCK", label: "Cocoseilanden"},
    {value: "COL", label: "Colombia"},
    {value: "COM", label: "Comoren"},
    {value: "COD", label: "Congo-Brazzaville"},
    {value: "COG", label: "Congo-Kinshasa"},
    {value: "COK", label: "Cookeilanden"},
    {value: "CRI", label: "Costa Rica"},
    {value: "CUB", label: "Cuba"},
    {value: "CUW", label: "Curaçao"},
    {value: "CYP", label: "Cyprus"},
    {value: "DNK", label: "Denemarken"},
    {value: "DJI", label: "Djibouti"},
    {value: "DMA", label: "Dominica"},
    {value: "DOM", label: "Dominicaanse Republiek"},
    {value: "DEU", label: "Duitsland"},
    {value: "ECU", label: "Ecuador"},
    {value: "EGY", label: "Egypte"},
    {value: "SLV", label: "El Salvador"},
    {value: "GNQ", label: "Equatoriaal-Guinea"},
    {value: "ERI", label: "Eritrea"},
    {value: "EST", label: "Estland"},
    {value: "ETH", label: "Ethiopië"},
    {value: "FLK", label: "Falklandeilanden"},
    {value: "FRO", label: "Faeröer"},
    {value: "FJI", label: "Fiji"},
    {value: "PHL", label: "Filipijnen"},
    {value: "FIN", label: "Finland"},
    {value: "FRA", label: "Frankrijk"},
    {value: "GUF", label: "Frans-Guyana"},
    {value: "PYF", label: "Frans-Polynesië"},
    {value: "ATF", label: "Franse Zuidelijke Gebieden"},
    {value: "GAB", label: "Gabon"},
    {value: "GMB", label: "Gambia"},
    {value: "GEO", label: "Georgië"},
    {value: "GHA", label: "Ghana"},
    {value: "GIB", label: "Gibraltar"},
    {value: "GRC", label: "Griekenland"},
    {value: "GRL", label: "Groenland"},
    {value: "GRD", label: "Grenada"},
    {value: "GLP", label: "Guadeloupe"},
    {value: "GUM", label: "Guam"},
    {value: "GTM", label: "Guatemala"},
    {value: "GGY", label: "Guernsey"},
    {value: "GIN", label: "Guinee"},
    {value: "GNB", label: "Guinee-Bissau"},
    {value: "GUY", label: "Guyana"},
    {value: "HTI", label: "Haïti"},
    {value: "HMD", label: "Heard en McDonaldeilanden"},
    {value: "HND", label: "Honduras"},
    {value: "HKG", label: "Hongkong"},
    {value: "HUN", label: "Hongarije"},
    {value: "ISL", label: "IJsland"},
    {value: "IND", label: "India"},
    {value: "IDN", label: "Indonesië"},
    {value: "IRN", label: "Iran"},
    {value: "IRQ", label: "Irak"},
    {value: "IRL", label: "Ierland"},
    {value: "ISR", label: "Israël"},
    {value: "ITA", label: "Italië"},
    {value: "CIV", label: "Ivoorkust"},
    {value: "JAM", label: "Jamaica"},
    {value: "JPN", label: "Japan"},
    {value: "YEM", label: "Jemen"},
    {value: "JEY", label: "Jersey"},
    {value: "JOR", label: "Jordanië"},
    {value: "KAZ", label: "Kazachstan"},
    {value: "KEN", label: "Kenia"},
    {value: "KIR", label: "Kiribati"},
    {value: "CPV", label: "Kaapverdië"},
    {value: "CMR", label: "Kameroen"},
    {value: "CYM", label: "Kaaimaneilanden"},
    {value: "KWT", label: "Koeweit"},
    {value: "KGZ", label: "Kirgizië"},
    {value: "HRV", label: "Kroatië"},
    {value: "LAO", label: "Laos"},
    {value: "LVA", label: "Letland"},
    {value: "LBN", label: "Libanon"},
    {value: "LSO", label: "Lesotho"},
    {value: "LBR", label: "Liberië"},
    {value: "LBY", label: "Libië"},
    {value: "LIE", label: "Liechtenstein"},
    {value: "LTU", label: "Litouwen"},
    {value: "LUX", label: "Luxemburg"},
    {value: "MAC", label: "Macau"},
    {value: "IMN", label: "Man"},
    {value: "MDG", label: "Madagaskar"},
    {value: "MWI", label: "Malawi"},
    {value: "MYS", label: "Maleisië"},
    {value: "MDV", label: "Malediven"},
    {value: "MLI", label: "Mali"},
    {value: "MLT", label: "Malta"},
    {value: "MHL", label: "Marshalleilanden"},
    {value: "MTQ", label: "Martinique"},
    {value: "MRT", label: "Mauritanië"},
    {value: "MUS", label: "Mauritius"},
    {value: "MYT", label: "Mayotte"},
    {value: "MEX", label: "Mexico"},
    {value: "FSM", label: "Micronesië"},
    {value: "MDA", label: "Moldavië"},
    {value: "MCO", label: "Monaco"},
    {value: "MNG", label: "Mongolië"},
    {value: "MNE", label: "Montenegro"},
    {value: "MSR", label: "Montserrat"},
    {value: "MAR", label: "Marokko"},
    {value: "MOZ", label: "Mozambique"},
    {value: "MMR", label: "Myanmar"},
    {value: "NAM", label: "Namibië"},
    {value: "NRU", label: "Nauru"},
    {value: "NPL", label: "Nepal"},
    {value: "NLD", label: "Nederland"},
    {value: "NCL", label: "Nieuw-Caledonië"},
    {value: "NZL", label: "Nieuw-Zeeland"},
    {value: "NIC", label: "Nicaragua"},
    {value: "NER", label: "Niger"},
    {value: "NGA", label: "Nigeria"},
    {value: "NIU", label: "Niue"},
    {value: "NFK", label: "Norfolk"},
    {value: "MNP", label: "Noordelijke Marianen"},
    {value: "NOR", label: "Noorwegen"},
    {value: "PRK", label: "Noord-Korea"},
    {value: "MKD", label: "Noord-Macedonië"},
    {value: "UGA", label: "Oeganda"},
    {value: "UKR", label: "Oekraïne"},
    {value: "UZB", label: "Oezbekistan"},
    {value: "OMN", label: "Oman"},
    {value: "AUT", label: "Oostenrijk"},
    {value: "PAK", label: "Pakistan"},
    {value: "PLW", label: "Palau"},
    {value: "PSE", label: "Palestina"},
    {value: "PAN", label: "Panama"},
    {value: "PNG", label: "Papoea-Nieuw-Guinea"},
    {value: "PRY", label: "Paraguay"},
    {value: "PER", label: "Peru"},
    {value: "PCN", label: "Pitcairneilanden"},
    {value: "POL", label: "Polen"},
    {value: "PRT", label: "Portugal"},
    {value: "PRI", label: "Puerto Rico"},
    {value: "QAT", label: "Qatar"},
    {value: "REU", label: "Réunion"},
    {value: "ROU", label: "Roemenië"},
    {value: "RUS", label: "Rusland"},
    {value: "RWA", label: "Rwanda"},
    {value: "BLM", label: "Saint-Barthélemy"},
    {value: "SHN", label: "Sint-Helena, Ascension en Tristan da Cunha"},
    {value: "KNA", label: "Saint Kitts en Nevis"},
    {value: "LCA", label: "Saint Lucia"},
    {value: "MAF", label: "Saint-Martin"},
    {value: "SPM", label: "Saint-Pierre en Miquelon"},
    {value: "VCT", label: "Saint Vincent en de Grenadines"},
    {value: "WSM", label: "Samoa"},
    {value: "SMR", label: "San Marino"},
    {value: "STP", label: "Sao Tomé en Principe"},
    {value: "SAU", label: "Saoedi-Arabië"},
    {value: "SEN", label: "Senegal"},
    {value: "SRB", label: "Servië"},
    {value: "SYC", label: "Seychellen"},
    {value: "SLE", label: "Sierra Leone"},
    {value: "SGP", label: "Singapore"},
    {value: "SXM", label: "Sint Maarten"},
    {value: "SVK", label: "Slowakije"},
    {value: "SVN", label: "Slovenië"},
    {value: "SLB", label: "Salomonseilanden"},
    {value: "SOM", label: "Somalië"},
    {value: "ESP", label: "Spanje"},
    {value: "LKA", label: "Sri Lanka"},
    {value: "SDN", label: "Soedan"},
    {value: "SJM", label: "Spitsbergen en Jan Mayen"},
    {value: "SUR", label: "Suriname"},
    {value: "SWZ", label: "Swaziland"},
    {value: "SYR", label: "Syrië"},
    {value: "TWN", label: "Taiwan"},
    {value: "TJK", label: "Tadzjikistan"},
    {value: "TZA", label: "Tanzania"},
    {value: "THA", label: "Thailand"},
    {value: "TLS", label: "Oost-Timor"},
    {value: "TGO", label: "Togo"},
    {value: "TKL", label: "Tokelau"},
    {value: "TON", label: "Tonga"},
    {value: "TTO", label: "Trinidad en Tobago"},
    {value: "TCD", label: "Tsjaad"},
    {value: "CZE", label: "Tsjechië"},
    {value: "TUN", label: "Tunesië"},
    {value: "TUR", label: "Turkije"},
    {value: "TKM", label: "Turkmenistan"},
    {value: "TCA", label: "Turks- en Caicoseilanden"},
    {value: "TUV", label: "Tuvalu"},
    {value: "URY", label: "Uruguay"},
    {value: "VUT", label: "Vanuatu"},
    {value: "VAT", label: "Vaticaanstad"},
    {value: "ARE", label: "Verenigde Arabische Emiraten"},
    {value: "GBR", label: "Verenigd Koninkrijk"},
    {value: "USA", label: "Verenigde Staten"},
    {value: "VEN", label: "Venezuela"},
    {value: "VNM", label: "Vietnam"},
    {value: "WLF", label: "Wallis en Futuna"},
    {value: "ESH", label: "Westelijke Sahara/SADR"},
    {value: "BLR", label: "Wit-Rusland"},
    {value: "ZMB", label: "Zambia"},
    {value: "ZWE", label: "Zimbabwe"},
    {value: "ZAF", label: "Zuid-Afrika"},
    {value: "SGS", label: "Zuid-Georgia en de Zuidelijke Sandwicheilanden"},
    {value: "KOR", label: "Zuid-Korea"},
    {value: "SSD", label: "Zuid-Soedan"},
    {value: "SWE", label: "Zweden"},
    {value: "CHE", label: "Zwitserland"}
  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzSbDataService,
    public sbService: BokkzSbLogic,
    private fb: FormBuilder) {
    this.schenkingFg = this.fb.group<Schenking>({
      datumSchenking: null as unknown as Date,
      relatieBegiftigdeMetSchenker: null as unknown as SchenkingRelatieBegiftigdeMetSchenker,
      herroepelijkeSchenking: null as unknown as boolean,
      schenkerBetaaltDeSchenkbelasting: null as unknown as boolean,
      uitbreidingBegripSchenker: null as unknown as boolean,
      contanten: null as unknown as OmschrijvingEnBedrag,
      effecten: null as unknown as Effecten,
      onroerendeZaken: null as unknown as OnroerendeZaakSB,
      ondernemingen: null as unknown as OndernemingSB,
      apv: null as unknown as APV,
      periodiekeUitkering: null as unknown as PU,
      roerendeZaak: null as unknown as RoerendeZaak,
      schuldigerkenning: null as unknown as SchenkingOpPapier,
      kwijtscheldingSchuld: null as unknown as OmschrijvingEnBedrag,
      vruchtgebruik: null as unknown as Vruchtgebruik,
      overige: null as unknown as OmschrijvingEnBedrag,
      vrijstellingen: null as unknown as Vrijstellingen,
      notarieleAkte: null as unknown as NotarieleAkte,
      belastingBetaaldInAnderLand: null as unknown as number,
      landCodeBetaaldInAnderLand: null as unknown as string,
      heffingsgrondslagOverdrachtsbelasting: null as unknown as number,
      betaaldeOverdrachtsbelasting: null as unknown as number,
      indicatieSchenkerVorigeEigenaar: null as unknown as boolean,
      datumJuridischeLevering: null as unknown as Date,
    })
  }

  ngOnInit(): void {
    this.giftTaxEntitySubscription = this.dataService.giftTaxEntity.subscribe((value)=> {
      this.giftTaxEntity = value;
      this.hasNLOnroerendeZaken = this.dataService.hasNLOnroerendeZaken.value
      this.sbAangifte = value.aangifte!;
      if (value.aangifte!.schenking) {
        this.schenkingFg.patchValue(value.aangifte!.schenking[0], {emitEvent: false})
      }
    })
  }

  ngOnDestroy(): void {
    if (this.giftTaxEntitySubscription) {
      this.giftTaxEntitySubscription.unsubscribe()
    }
  }

  saveForm(): void {
    this.schenkingFg.updateValueAndValidity({ emitEvent: false });
    const schenking = this.schenkingFg.value;
    schenking.belastingBetaaldInAnderLand = this.schenkingFg.value.belastingBetaaldInAnderLand;
    schenking.landCodeBetaaldInAnderLand = this.schenkingFg.value.landCodeBetaaldInAnderLand;
    schenking.heffingsgrondslagOverdrachtsbelasting = this.schenkingFg.value.heffingsgrondslagOverdrachtsbelasting;
    schenking.betaaldeOverdrachtsbelasting = this.schenkingFg.value.betaaldeOverdrachtsbelasting;
    schenking.indicatieSchenkerVorigeEigenaar = this.schenkingFg.value.indicatieSchenkerVorigeEigenaar;
    schenking.datumJuridischeLevering = this.schenkingFg.value.datumJuridischeLevering;
    this.giftTaxEntity.aangifte = {
      ...this.sbAangifte,
      schenking: [schenking],
    } as AangifteSchenkbelasting;
    this.dataService.updateGiftTaxEntity(this.giftTaxEntity);
    setTimeout(()=> {
      this.sbService.getCalculation();
    }, 1500)
  }
}
